import React from 'react';
import { Typography, IconButton, Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Add as AddIcon } from '@mui/icons-material';
import classNames from 'classnames';
import styles from '../styles';
import withStyles from '@mui/styles/withStyles';

const useStyles = makeStyles(theme => ({
  itemHeader: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderRadius: 0,
    '&:before': {
      position: 'absolute',
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: theme.palette.divider,
    },
  },
  rightPanel: {
    display: 'flex',
    alignItems: 'center',
  },
  counter: {
    marginRight: theme.spacing(2),
  },
  addButton: {
    padding: 0,
  },
}));

export const ItemHeader = withStyles(styles)(({
  title,
  onAddClick,
  counter,
  isHighlighted,
  classes: sharedClasses,
}) => {
  const classes = useStyles();

  return (
    <Paper
      className={classNames(classes.itemHeader, {
        [sharedClasses.warning]: isHighlighted,
      })}
      elevation={1}
    >
      <Typography>{title}</Typography>
      <div className={classes.rightPanel}>
        <div className={classes.counter}>{counter}</div>
        <IconButton
          className={classes.addButton}
          onClick={onAddClick}
          size="large"
        >
          <AddIcon />
        </IconButton>
      </div>
    </Paper>
  );
});
